/**
 * Casa Platino — Size Guide Component
 *
 * Renders a size/dimensions table with IN/CM toggle for sheet products.
 * Inspired by Bedsure's size guide pattern.
 *
 * Usage:
 *   <div data-size-guide="egyptian-cotton-1000tc"></div>
 *   <script src="assets/size-guide.js"></script>
 */

window.CP_SIZE_DATA = {
  // All dimensions in INCHES; "flat": [W, L], "fitted": [W, L, pocket], "pillow": [W, L]
  "egyptian-cotton-1000tc": {
    title: "Egyptian Cotton Sheet Set — Dimensions",
    rows: [
      { size: "Full",            flat: [85, 100],  fitted: [55, 76, 15],  pillow: [20, 26], mattress: "53–54 × 75 × 8–16" },
      { size: "Queen",           flat: [94, 104],  fitted: [61, 81, 15],  pillow: [20, 30], mattress: "60 × 80 × 8–16" },
      { size: "King",            flat: [112, 104], fitted: [79, 81, 15],  pillow: [20, 36], mattress: "76 × 80 × 8–16" },
      { size: "California King", flat: [108, 108], fitted: [72, 84, 15],  pillow: [20, 36], mattress: "72 × 84 × 8–16" }
    ]
  },
  "450tc-cotton": {
    title: "450 Thread Count Cotton Sheet Set — Dimensions",
    rows: [
      { size: "Twin",            flat: [68, 98],   fitted: [39, 75, 15],  pillow: [20, 30], mattress: "38–39 × 75 × 8–16" },
      { size: "Twin XL",         flat: [64, 104],  fitted: [39, 80, 15],  pillow: [20, 30], mattress: "38–39 × 80 × 8–16" },
      { size: "Full",            flat: [83, 98],   fitted: [54, 75, 15],  pillow: [20, 30], mattress: "53–54 × 75 × 8–16" },
      { size: "Queen",           flat: [90, 102],  fitted: [60, 80, 15],  pillow: [20, 30], mattress: "60 × 80 × 8–16" },
      { size: "King",            flat: [93, 104],  fitted: [60, 80, 15],  pillow: [20, 30], mattress: "76 × 80 × 8–16" },
      { size: "California King", flat: [108, 108], fitted: [72, 84, 15],  pillow: [20, 40], mattress: "72 × 84 × 8–16" }
    ]
  },
  "600tc-cotton": {
    title: "600 Thread Count Cotton Sheet Set — Dimensions",
    rows: [
      { size: "Twin",            flat: [66, 96],   fitted: [39, 75, 15],  pillow: [20, 26], mattress: "38–39 × 75 × 8–16" },
      { size: "Twin XL",         flat: [66, 96],   fitted: [39, 80, 15],  pillow: [20, 30], mattress: "38–39 × 80 × 8–16" },
      { size: "Full",            flat: [85, 100],  fitted: [55, 76, 15],  pillow: [20, 30], mattress: "53–54 × 75 × 8–16" },
      { size: "Queen",           flat: [94, 104],  fitted: [61, 81, 15],  pillow: [20, 30], mattress: "60 × 80 × 8–16" },
      { size: "King",            flat: [112, 104], fitted: [79, 81, 15],  pillow: [20, 40], mattress: "76 × 80 × 8–16" },
      { size: "California King", flat: [104, 104], fitted: [72, 84, 15],  pillow: [20, 40], mattress: "72 × 84 × 8–16" }
    ]
  },
  "percale-cotton": {
    title: "Percale Cotton Sheet Set — Dimensions",
    rows: [
      { size: "Twin",            flat: [66, 96],   fitted: [39, 75, 15],  pillow: [20, 30], mattress: "38–39 × 75 × 8–16" },
      { size: "Twin XL",         flat: [66, 100],  fitted: [39, 80, 15],  pillow: [20, 30], mattress: "38–39 × 80 × 8–16" },
      { size: "Full",            flat: [81, 96],   fitted: [54, 75, 15],  pillow: [20, 30], mattress: "53–54 × 75 × 8–16" },
      { size: "Queen",           flat: [90, 102],  fitted: [60, 80, 15],  pillow: [20, 30], mattress: "60 × 80 × 8–16" },
      { size: "King",            flat: [108, 102], fitted: [78, 80, 15],  pillow: [20, 40], mattress: "76 × 80 × 8–16" },
      { size: "California King", flat: [108, 102], fitted: [72, 84, 15],  pillow: [20, 40], mattress: "72 × 84 × 8–16" }
    ]
  },
  "flannel-cotton": {
    title: "Flannel Cotton Sheet Set — Dimensions",
    rows: [
      { size: "Twin",            flat: [66, 96],   fitted: [39, 75, 15],  pillow: [20, 30], mattress: "38–39 × 75 × 8–16" },
      { size: "Twin XL",         flat: [66, 100],  fitted: [39, 80, 15],  pillow: [20, 30], mattress: "38–39 × 80 × 8–16" },
      { size: "Full",            flat: [81, 96],   fitted: [54, 75, 15],  pillow: [20, 30], mattress: "53–54 × 75 × 8–16" },
      { size: "Queen",           flat: [90, 102],  fitted: [60, 80, 15],  pillow: [20, 30], mattress: "60 × 80 × 8–16" },
      { size: "King",            flat: [108, 102], fitted: [78, 80, 15],  pillow: [20, 40], mattress: "76 × 80 × 8–16" },
      { size: "California King", flat: [108, 102], fitted: [72, 84, 15],  pillow: [20, 40], mattress: "72 × 84 × 8–16" }
    ]
  },
  "microfiber": {
    title: "Washed Microfiber Sheet Set — Dimensions",
    rows: [
      { size: "Twin",            flat: [66, 96],   fitted: [39, 75, 14],  pillow: [20, 30], mattress: "38–39 × 75 × 8–16" },
      { size: "Full",            flat: [81, 96],   fitted: [54, 75, 14],  pillow: [20, 30], mattress: "53–54 × 75 × 8–16" },
      { size: "Queen",           flat: [90, 102],  fitted: [60, 80, 14],  pillow: [20, 30], mattress: "60 × 80 × 8–16" },
      { size: "King",            flat: [108, 102], fitted: [78, 80, 14],  pillow: [20, 40], mattress: "76 × 80 × 8–16" },
      { size: "California King", flat: [108, 102], fitted: [72, 84, 14],  pillow: [20, 40], mattress: "72 × 84 × 8–16" },
      { size: "Split King",      flat: [108, 102], fitted: [39, 80, 14],  pillow: [20, 40], mattress: "38–39 × 80 × 8–16 (×2)" }
    ]
  }
};

/** Convert inches to cm (rounded to nearest cm) */
function inToCm(n) { return Math.round(n * 2.54); }

/** Format dimension display */
function fmtFlat(dims, unit) {
  if (unit === 'cm') return inToCm(dims[0]) + ' × ' + inToCm(dims[1]);
  return dims[0] + '" × ' + dims[1] + '"';
}
function fmtFitted(dims, unit) {
  if (unit === 'cm') {
    return inToCm(dims[0]) + ' × ' + inToCm(dims[1]) + ' + ' + inToCm(dims[2]) + ' cm pocket';
  }
  return dims[0] + '" × ' + dims[1] + '" + ' + dims[2] + '" pocket';
}
function fmtPillow(dims, unit) {
  if (unit === 'cm') return inToCm(dims[0]) + ' × ' + inToCm(dims[1]);
  return dims[0] + '" × ' + dims[1] + '"';
}
function fmtMattress(str, unit) {
  if (unit === 'in') return str + ' in';
  // Convert each number in the string from inches to cm
  return str.replace(/(\d+(?:\.\d+)?)(?:–(\d+(?:\.\d+)?))?/g, function(_, a, b) {
    if (b) return inToCm(parseFloat(a)) + '–' + inToCm(parseFloat(b));
    return inToCm(parseFloat(a));
  }) + ' cm';
}

/** Build the HTML for the size guide */
window.CP_renderSizeGuide = function renderSizeGuide(container, key) {
  var data = window.CP_SIZE_DATA[key];
  if (!data) {
    container.innerHTML = '<p>Size guide not found.</p>';
    return;
  }

  var unit = 'in';

  function build() {
    var html = '' +
      '<div class="cp-size-guide">' +
      '  <div class="cp-size-guide__toggle">' +
      '    <button class="cp-size-guide__unit' + (unit === 'in' ? ' is-active' : '') + '" data-unit="in">IN</button>' +
      '    <button class="cp-size-guide__unit' + (unit === 'cm' ? ' is-active' : '') + '" data-unit="cm">CM</button>' +
      '  </div>' +
      '  <div class="cp-size-guide__table-wrap">' +
      '    <table class="cp-size-guide__table">' +
      '      <thead>' +
      '        <tr>' +
      '          <th>Size / Items</th>' +
      '          <th>Flat Sheet</th>' +
      '          <th>Fitted Sheet</th>' +
      '          <th>Pillowcase Size</th>' +
      '          <th>Suitable Mattress (Fitted Sheet)</th>' +
      '        </tr>' +
      '      </thead>' +
      '      <tbody>';
    data.rows.forEach(function(r) {
      html += '' +
        '        <tr>' +
        '          <td class="cp-size-guide__size">' + r.size + '</td>' +
        '          <td>' + fmtFlat(r.flat, unit) + '</td>' +
        '          <td>' + fmtFitted(r.fitted, unit) + '</td>' +
        '          <td>' + fmtPillow(r.pillow, unit) + '</td>' +
        '          <td>' + fmtMattress(r.mattress, unit) + '</td>' +
        '        </tr>';
    });
    html += '' +
      '      </tbody>' +
      '    </table>' +
      '  </div>' +
      '  <p class="cp-size-guide__note">All measurements are approximate. Fully elasticized fitted sheet stays secure on mattresses up to 17" (43 cm) deep.</p>' +
      '</div>';
    container.innerHTML = html;

    // Attach toggle listeners
    container.querySelectorAll('.cp-size-guide__unit').forEach(function(btn) {
      btn.addEventListener('click', function() {
        unit = btn.getAttribute('data-unit');
        build();
      });
    });
  }

  build();
};

/** Auto-init any elements with data-size-guide attribute */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-size-guide]').forEach(function(el) {
    var key = el.getAttribute('data-size-guide');
    window.CP_renderSizeGuide(el, key);
  });
});
